<template>
  <div class="booking-add-ons-carousel-wrapper">
    <carousel
      :key="`add-ons-carousel-${addOnsList.length}`"
      selector=".carousel-wrapper"
      variant="booking-add-ons"
    >
      <section
        slot-scope="{ imageLoadedEvent, canLoad }"
        class="carousel component booking-add-ons-carousel"
      >
        <div class="carousel-wrapper">
          <BookingAddOnsSlide
            v-for="(addOn, index) in addOnsList"
            :key="`addOn-${index}`"
            :add-on="addOn"
            :image-loaded-event="imageLoadedEvent"
            :can-load="canLoad"
            @select-add-on="$emit('select-add-on', $event)"
            @remove-add-on="removeAddOn($event)"
            @edit-add-on="$emit('edit-add-on', $event)"
          />
        </div>
      </section>
    </carousel>
    <modal
      ref="addonCancelModal"
      :value="isOpen"
      variant="default"
      no-footer
      class="modify-modal modify-modal__cancel"
      aria-labelled-by="modify-cancel-modal-title"
      @input="handleOpenModal"
      @close="handleCloseModal"
    >
      <template #header>
        <div
          id="modify-cancel-modal-title"
          class="title"
        >
          {{ ModifyReservationAddOnsCancelPopupTitle }}
        </div>
      </template>

      <template #body="{}">
        <div class="modify-modal__cancel-fees">
          <span class="cancel-icon" />
          <span>{{ ModifyReservationAddOnsCancelPopupFeesMessage }}</span>
        </div>
        <div class="button-wrapper form-submit">
          <button
            class="button--primary black size-md"
            @click="cancelAddOn"
            @keydown.space.prevent="cancelAddOn"
            @keydown.enter.prevent="cancelAddOn"
          >
            <span>Cancel</span>
          </button>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import BookingAddOnsSlide from './booking-add-ons-slide'

  export default {
    name: 'BookingAddOnsCarousel',
    components: {
      BookingAddOnsSlide
    },
    props: {
      addOnsList: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      isOpen: false,
      selectedAddOnData: null,
    }),
    computed: {
      ...mapState('booking', ['currentRoomId']),
      ...mapState('responsive', { wWidth: 'width' }),
      ...mapState('modifyReservation', ['modifyBookingPropData']),
      ...mapGetters('i18n', ['tc']),

      ModifyReservationAddOnsCancelPopupFeesMessage() {
        return this.modifyBookingPropData?.ModifyReservationAddOnsCancelPopupFeesMessage
          ? this.modifyBookingPropData.ModifyReservationAddOnsCancelPopupFeesMessage
          : ''
      },
      ModifyReservationAddOnsCancelPopupTitle() {
        return this.modifyBookingPropData?.ModifyReservationAddOnsCancelPopupTitle
          ? this.modifyBookingPropData.ModifyReservationAddOnsCancelPopupTitle
          : ''
      },
    },
    watch: {
      isOpen(val) {
        document.body.classList.toggle('no-scroll', val)
      }
    },
    methods: {
      deactivate() {
        this.$emit('deactivate')
      },
      handleCloseModal() {
        this.isOpen = false
      },
      handleOpenModal() {
        this.isOpen = true
      },
      cancelAddOn() {
        this.$emit('remove-add-on', this.selectedAddOnData)
        this.$refs.addonCancelModal.deactivate()
        this.selectedAddOnData = null
      },
      async removeAddOn(data) {
        if (data.openCancelModal) {
          this.selectedAddOnData = data.selectedAddOnData
          this.$refs.addonCancelModal.activate()
        } else {
          this.$emit('remove-add-on', data.selectedAddOnData)
        }
      }
    }
  }
</script>
